export const ApplicationRoles = {
    Administrator: "Administrator",
    Owner: "Owner",
    ProjectManager: "ProjectManager",
    Viewer: "Viewer"
}

export const ProjectSaveMode = {
    AllProjects: 0,
    MyProjects: 1
}